import * as React from 'react'

import styled from 'styled-components'
import { Property } from 'csstype'
import { DOMAttributes } from 'react';

interface FlexInterface extends React.CSSProperties, React.PropsWithChildren, DOMAttributes<any> {
    justify?: string
    direction?: any
    wrap?: string
    align?: string
    className?: string
    paddingLeft?: string
    style?: React.CSSProperties
    title?: string
}


interface SFlexInterface {
    $justify?: string
    $direction: Property.FlexDirection
    $wrap?: string
    $align?: string
    $className?: string
    $paddingLeft?: string
    $style?: React.CSSProperties
}

const SFlex = styled.div<SFlexInterface>`
    display: flex;
    flex-wrap: ${(props) => props.$wrap ?? 'no-wrap'};
    flex-direction: ${(props) => props.$direction ?? 'row'};
    align-items: ${(props) => props.$align ?? 'center'};
    justify-content: ${(props) => props.$justify ?? 'center'};
    padding-left: ${(props) => props.$paddingLeft};
    className: ${(props) => props.$className};
`;

const Flex: React.FC<FlexInterface> = (props) => {
    const {paddingLeft, direction, justify, wrap, align, translate, className, ...rest} = props

    return (

    <SFlex
        $paddingLeft={paddingLeft}
        $direction={direction??'row'}
        $wrap={wrap}
        $justify={justify}
        $align={align}
        $className={className}
        {...rest}
    >
        {props.children}
    </SFlex>
    )
}


export default Flex;